import Vue from 'vue'
import vuex from 'vuex'
import axios from '@/http/axiosInstance.js'


Vue.use(vuex)

import app from './modules/app'
import detail from './modules/detail'
import user from './modules/user'
let dictionary = {}
const dictionarySession = sessionStorage.getItem("dictionary")

if (dictionarySession && dictionarySession != "{}") {
    dictionary = JSON.parse(dictionarySession)
} else {
    const that = new Vue()
    setTimeout(() => {
        that.$http.GET_dictJson().then((res) => {
            let resData = res.data.data||res.data
            if (resData) {
				if(!resData.VEHICLEBRAND){
					axios({
						url:"/json/dictionary/vehicleBrand.json"
					}).then((res2) => {
						if (res2) {
							resData.VEHICLEBRAND = JSON.parse(res2)
							store.commit('dictionary', resData)
							sessionStorage.setItem('dictionary', JSON.stringify(resData))
						}
					})
				}else{
					store.commit('dictionary', resData)
					sessionStorage.setItem('dictionary', JSON.stringify(resData))
				}
            }
        })
    }, 350);
}

const store = new vuex.Store({
    modules: {
        app,
        detail,
        user
    },
    state: {
        token: '',
        sbNav:{},
        info:{},
        topnav_activeNav1: 0,  //激活的菜单当前项
        isRefreshReportBox: null,
        isRefreshWarningBox: null,
        alarmConfigList: [],
        dictionary,
        documentTitle: null,
        documentTitle_menuName: null,
        dbClickImg: {
            src: '',
            show: false
        },
        enlargeDv: {
            src: '',
            show: false
        },
        eventListBox: {
            eventList: [],
            show: false
        },
        vuex_allmenu:[],
        hadIgnoreForm: '',
        voiceElOpen: 0,  //用0，1，2， 初始化语音识别功能，因为有不同问候语
        deviceIdList: [],
        responsibleDepartments: [],
        busunessMapMaskRoundLngLat: [],
        bigDataLastDate: {},
        myEventObj: null
    },
    mutations: {
        SET_sbNav(state, data) {
            state.sbNav = data
        },
        SET_allMenu(state, data) {
            state.vuex_allmenu = data
        },
        SET_TOKEN(state, data) {
            state.token = data
        },
        SET_info(state, data) {
            state.info = data
        },
        topnav_activeNav1(state, data) {
            state.topnav_activeNav1 = data
        },
        documentTitle_menuName(state, data) {
            state.documentTitle_menuName = data
        },
        documentTitle(state, data) {
            state.documentTitle = data
        },
        dictionary(state, data) {
            state.dictionary = data
        },
        set_dbClickImg(state, src) {
            if (src) {
                state.dbClickImg = {
                    src,
                    show: true
                }
                if (state.enlargeDv.show) state.enlargeDv.show = false
            } else {
                state.dbClickImg = {
                    src,
                    show: false
                }
            }
        },
        set_enlargeDv(state, src) {
            if (src) {
                state.enlargeDv = {
                    src,
                    show: true
                }
                if (state.dbClickImg.show) state.dbClickImg.show = false
            } else {
                state.enlargeDv = {
                    src,
                    show: false
                }
            }
        },
        set_eventListBox(state, obj) {
            let eventListBox = {};
            if (obj.show !== "undefined") {
                eventListBox.show = obj.show;
            }
            if (obj.eventList) {
                eventListBox.eventList = obj.eventList;
            }
            state.eventListBox = Object.assign({}, state.eventListBox, eventListBox)
        },
        set_deviceIdList(state, data) {
            state.deviceIdList = data
        },
        set_bigData_last_date(state, name) {
            const obj = {
                times: new Date().getTime(),
                name: name ? name : 'event_alarm'
            }
            state.bigDataLastDate = obj
        },
    },
    actions: {
        // set_responsibleDepartments (context) {
        // context.commit('set_responsibleDepartments')
        // }
    },
    getters: {
        get_userInfo(state){
            return state.info||JSOM.parse(localStorage.getItem("userInfo"))
        },
        get_userAuthorities(state){
            return state.info.authorities[0]||JSOM.parse(localStorage.getItem("userInfo")).authorities[0]
        }
    }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js